import styled from 'styled-components';
import getColour, { ValidHex } from '@lendi-ui/commons/colours';
import { ml } from '@lendi-ui/spacing';
import { link } from '@lendi-ui/typography';

interface ButtonProps {
  color?: ValidHex;
}

export const Button = styled.button<ButtonProps>`
  ${link({ size: 'xs' }) as {}};
  color: ${(props) => props.color || getColour('interaction', 'subtle')};
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 700;
  letter-spacing: 1px;
  text-decoration: none;
  text-transform: uppercase;

  &:hover,
  &:focus,
  &:active {
    border: none;
    outline: none;
    text-decoration: none;
  }
`;

export const IconContainer = styled.div`
  display: inline-block;
  position: relative;
  top: -1px;
  ${ml('xs')};
`;
